import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/site/PageHero";
import { getPost } from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0); setPost(null); setNotFound(false);
    getPost(slug).then(setPost).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="pt-40 pb-40 text-center"><h1 className="font-serif text-4xl text-[#3b1a1a]">Article not found</h1><Link to="/blog" className="mt-6 inline-block text-[#7c1d1d] uppercase tracking-[0.2em] text-xs">← Back to blog</Link></div>;
  if (!post) return <div className="pt-40 pb-40 text-center text-[#5a4b4b]">Loading…</div>;

  const schema = { "@context": "https://schema.org", "@type": "Article", headline: post.title, image: post.featured_image, author: { "@type": "Organization", name: post.author }, datePublished: post.published_at };

  return (
    <>
      <Seo title={post.seo?.meta_title || post.title} description={post.seo?.meta_description || post.excerpt} image={post.featured_image} type="article" schema={schema} />
      <PageHero title={post.title} subtitle={post.category} image={post.featured_image} crumbs={[{ label: "Blog", to: "/blog" }, { label: post.category }]} />

      <article className="py-16 sm:py-24 bg-[#fdfbf7]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <div className="flex items-center gap-3 text-[11px] tracking-[0.2em] uppercase text-[#5a4b4b] mb-8">
            <span className="text-[#7c1d1d]">{post.author}</span>
            {post.published_at && <span>· {new Date(post.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</span>}
          </div>
          <div className="prose-wan" data-testid="blog-content" dangerouslySetInnerHTML={{ __html: post.content }} />
          {post.tags?.length > 0 && (
            <div className="mt-10 pt-6 border-t border-[#d4af37]/25 flex flex-wrap gap-2">
              {post.tags.map((t) => <span key={t} className="text-[11px] tracking-[0.15em] uppercase text-[#14523d] border border-[#d4af37]/30 px-3 py-1">#{t}</span>)}
            </div>
          )}
          <div className="mt-12"><Link to="/blog" className="text-xs tracking-[0.2em] uppercase text-[#7c1d1d]">← Back to all articles</Link></div>
        </div>
      </article>
    </>
  );
}
